import { DataBean } from "../DataBean";

export class SelectLabourByPorductionOrder extends DataBean {


    public async getLabourCatalogByProductionOrder(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLabourCatalogByProductionOrder_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }


 
}